export default __webpack_public_path__ + "static/media/wifi.2061bd29.svg";